(function () {
    'use strict';

    angular
        .module('app.departments')
        .controller('DepartmentDetailController', DepartmentDetailController);

    DepartmentDetailController.$inject = [
        '$state', '$stateParams',
        'bootstrap.dialog', 'common', 'dataservice'
    ];

    function DepartmentDetailController($state, $stateParams, bsDialog, common, dataservice) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;
        vm.countOfUsersInDepartments = { ActiveCount: 0, Name: -1 };
        vm.countOfCompletionTypesInDepartments = { ActiveCount: 0, Name: -1 };
        
        vm.cancel = cancel;
        vm.deleteItem = deleteItem;
        vm.deleteTitle = "";
        vm.isSaving = false;
        vm.save = save;
        vm.isNew = isNew;
        vm.preventDelete = preventDelete;
        vm.relationshipData = {
            Users: [],
            CompletionTypes: []
        };
        
        activate();

        function activate() {
            var promises = [common.checkIsAdmin() , initLookups(), getItem(), getCounts()];
            return common.$q.all(promises).then(function (data) {
            }, function (error) { });
        }

        function cancel() {
            backToList();
        }

        function backToList() {
            $state.go("departments.list");
        }

        function preventDelete() {
            var usersInDepartment = vm.countOfUsersInDepartments.ActiveCount;
            var completionTypesInDepartment = 0;
            if (vm.countOfCompletionTypesInDepartments) {
                completionTypesInDepartment = vm.countOfCompletionTypesInDepartments;
            }


            if (usersInDepartment > 0) {
                vm.deleteTitle = "You can't delete a department that a user belongs to";
            }

            if (completionTypesInDepartment > 0) {
                vm.deleteTitle = "You can't delete a department that has completion types";
            }

            if ($stateParams.id <= 0 || usersInDepartment > 0 || completionTypesInDepartment > 0) {
                return true;
            }
            
            return false;
        }

        function deleteItem() {
            return bsDialog.deleteDialog('Department')
                .then(confirmDelete, function () { });

            function confirmDelete() {
                dataservice.deleteItem("api/Departments/" + vm.item.ID).then(success).catch(failed);

                function success() {
                    backToList();
                }

                function failed(error) {
                    logger.error(error);
                }
            }
        }

        function isNew() {
            var val = $stateParams.id; 
            return val === "-1";
        }

        function getCounts() {
            if($stateParams.id > 0) {
                dataservice.getItems('api/Departments/CountsOfUsersInDepartment/' + $stateParams.id).then(function (response) {
                    if (response.data && response.data.length > 0) {
                        vm.countOfUsersInDepartments = response.data[0];
                    }
                }, function (error) { });

                dataservice.getItems('api/Departments/GetCountOfCompletionTypesByDepartment/' + $stateParams.id).then(function (response) {
                    if (response.data && response.data.length > 0) {
                        vm.countOfCompletionTypesInDepartments = response.data[0];
                    }
                }, function (error) { });
            }
            else {
                vm.countOfUsersInDepartments = { ActiveCount: 0, Name: -1 };
                vm.countOfCompletionTypesInDepartments = { ActiveCount: 0, Name: -1 };
            }
        }

        function getItem() {
            var val = $stateParams.id;
            if (val === '-1') {
                vm.item = {};
                vm.item.ID = -1;
                vm.item.UserIds = [];
                vm.item.Active = 1;
                
                common.setAuditInfo(vm.item);
                return vm.item;
            }

            return dataservice.getItem("api/Departments/" + val)
                .then(function (response) {
                    if (response) {
                        vm.item = response.data;
                        common.setAuditInfo(vm.item);
                        common.convertDateStringsToDates(vm.filters);
                        
                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }


        function initLookups() {
            dataservice.getItems('api/Users/GetActive').then(function (response) {
                var data = response.data;
                vm.relationshipData.Users = data;
                return;
            }, function (error) { });
        }

        function save() {
            vm.isSaving = true;

            dataservice.saveItem('api/Departments', vm.item).then(function (saveResult) {
                vm.isSaving = false;
                backToList();
            }).catch(function (error) {
                vm.isSaving = false;
            });
        }
    }
})();
